import SchoolEvents from './SchoolEvents';

export default SchoolEvents;
